import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setTradeDialog } from '../../../redux/reducer/dialog';
import useAuth from '../../../hooks/useAuth';
import { useAppSelector } from '../../../redux/app';
import { Navigate } from 'react-router-dom';
import { DirectionIcons, MenuIcons, OtherIcons } from '@vt/vt-ui';
import { MenuIcon } from 'lucide-react';

const LeftPanel = () => {
  const dispatch = useDispatch();
  const [active, setActive] = useState('');
  const { logout } = useAuth();
  const { isOpen, type } = useAppSelector((state) => state.tradeDialog);

  const handleOpenDrawer = (type, action) => {
    if (isOpen) {
      if (type === active) {
        dispatch(setTradeDialog({ isOpen: false, type: '' }));
      } else {
        dispatch(setTradeDialog({ isOpen: action, type }));
        setActive(type);
      }
    } else {
      dispatch(setTradeDialog({ isOpen: action, type }));
      setActive(type);
    }
  };

  const handleLogout = async () => {
    await logout();
    // <Navigate to="login" />
  };

  return (
    <div
      style={{
        transition: 'all 0.3s ease 0s'
      }}
    >
      <div className="menu-left">
        <div className="center-column">
          <div
            className={`menu-item ${active === 'trade' ? (type !== '' ? 'active' : '') : ''}`}
            onClick={() => {
              handleOpenDrawer('trade', true);
            }}
          >
            <DirectionIcons.Sort className='w-5 h-5' />
            <div className="text-menu prevent-select">Trading</div>
          </div>
          <div
            className={`menu-item ${active === 'port' ? (type !== '' ? 'active' : '') : ''}`}
            onClick={() => {
              handleOpenDrawer('port', true);
            }}
          >
            <MenuIcons.PieChart className='w-5 h-5' />
            <div className="text-menu prevent-select">All Port</div>
          </div>
          <div
            className={`menu-item ${active === 'history' ? (type !== '' ? 'active' : '') : ''}`}
            onClick={() => {
              handleOpenDrawer('history', true);
            }}
          >
            <OtherIcons.History className='w-5 h-5' />
            <div className="text-menu prevent-select">History</div>
          </div>
        </div>
        <div className="sidebar-draggable h-[calc(100vh_-_319px)]"></div>
        <div className="absolute left-0 bottom-4 translate-x-[25px] -translate-y-[15px] z-10">
          <button
            type="button"
            className="button-outline-logout group"
            onClick={handleLogout}
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="transition-colors duration-200"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.0889 9.41046C18.4144 9.7359 18.4144 10.2635 18.0889 10.589L14.7556 13.9223C14.4302 14.2477 13.9025 14.2477 13.5771 13.9223C13.2516 13.5969 13.2516 13.0692 13.5771 12.7438L15.4878 10.833H7.49967C7.03944 10.833 6.66634 10.46 6.66634 9.99972C6.66634 9.53948 7.03944 9.16638 7.49967 9.16638H15.4878L13.5771 7.25564C13.2516 6.9302 13.2516 6.40256 13.5771 6.07713C13.9025 5.75169 14.4302 5.75169 14.7556 6.07713L18.0889 9.41046ZM11.6663 2.49972C11.6663 2.95995 11.2932 3.33305 10.833 3.33305L5.16699 3.33305C4.68653 3.33305 4.3763 3.3337 4.14019 3.35299C3.9138 3.37149 3.82987 3.40288 3.78867 3.42388C3.63187 3.50377 3.50438 3.63126 3.42449 3.78806C3.40349 3.82926 3.3721 3.91319 3.3536 4.13958C3.33431 4.37569 3.33366 4.68592 3.33366 5.16638V14.833C3.33366 15.3135 3.33431 15.6237 3.3536 15.8599C3.3721 16.0862 3.40349 16.1702 3.42449 16.2114C3.50438 16.3682 3.63187 16.4957 3.78867 16.5756C3.82987 16.5965 3.9138 16.6279 4.14019 16.6464C4.3763 16.6657 4.68653 16.6664 5.16699 16.6664H10.833C11.2932 16.6664 11.6663 17.0395 11.6663 17.4997C11.6663 17.96 11.2932 18.333 10.833 18.333H5.13485C4.69557 18.3331 4.31661 18.3331 4.00447 18.3076C3.67501 18.2807 3.34733 18.2212 3.03202 18.0606C2.56161 17.8209 2.17916 17.4384 1.93948 16.968C1.77881 16.6527 1.71939 16.325 1.69247 15.9956C1.66697 15.6834 1.66698 15.3045 1.66699 14.8652V5.13424C1.66698 4.69496 1.66697 4.316 1.69247 4.00386C1.71939 3.67441 1.77881 3.34672 1.93948 3.03141C2.17916 2.561 2.56161 2.17855 3.03202 1.93887C3.34733 1.77821 3.67501 1.71878 4.00447 1.69186C4.31661 1.66635 4.69558 1.66637 5.13487 1.66638L10.833 1.66638C11.2932 1.66638 11.6663 2.03948 11.6663 2.49972Z"
                fill="#9F9F9F"
                className="transition-colors duration-200 group-hover:fill-[#0FEF9E]"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default LeftPanel;
